const env = import.meta.env;

function telHref(phone: string): string | undefined {
  if (!phone) return undefined;
  const digitsOnly = phone.replace(/\D/g, "");
  return `tel:+91${digitsOnly}`;
}

function displayPhone(phone: string): string {
  if (!phone) return "";
  return `+91 ${phone}`;
}

export const siteConfig = {
  companyName: env.VITE_COMPANY_NAME,
  loginLink: env.VITE_LOGIN_LINK,
  applyLink: env.VITE_APPLY_LINK,
  repayNowLink: env.VITE_REPAY_NOW,

  phone: env.VITE_COMPANY_PHONE,
  phoneDisplay: displayPhone(env.VITE_COMPANY_PHONE),
  phoneHref: telHref(env.VITE_COMPANY_PHONE),
  email: env.VITE_COMPANY_EMAIL,
  supportEmail: env.VITE_COMPANY_SUPPORT_EMAIL,
  complaintEmail: env.VITE_COMPANY_COMPLAINT_EMAIL,
  address: env.VITE_COMPANY_ADDRESS,

  lspName: env.VITE_COMPANY_LSP_NAME,
  lspUrl: env.VITE_COMPANY_LSP_URL,

  nbfcName: env.VITE_COMPANY_NBFC,
  nbfcAddress: env.VITE_COMPANY_NBFC_ADDRESS,
  nbfcLicense: env.VITE_COMPANY_NBFC_LICENSE,
  rbiLicense: env.VITE_RBI_LICENSE,
  bseScripCode: env.VITE_BSE_SCRIP_CODE,

  apiBaseUrl: env.VITE_APP_API_BASE_URL,
  brandId: env.VITE_BRAND_ID,

  social: {
    facebook: env.VITE_COMPANY_FACEBOOK_URL,
    twitter: env.VITE_COMPANY_TWITTER_URL,
    instagram: env.VITE_COMPANY_INSTAGRAM_URL,
    linkedin: env.VITE_COMPANY_LINKEDIN_URL,
    whatsapp: env.VITE_COMPANY_WHATSAPP_URL,
  },

  paymentMethod: env.VITE_BRAND_PAYMENT_METHOD,
  nbfcEmail: env.VITE_NBFC_EMAIL,

  grievance: {
    nbfcOfficerEmail: env.VITE_NBFC_GRIEVANCE_OFFICER_EMAIL,
    nbfcNodalEmail: env.VITE_NBFC_NODAL_OFFICER_EMAIL,
    officerName: env.VITE_BRAND_GRIEVANCE_OFFICER_NAME,
    officerEmail: env.VITE_BRAND_GRIEVANCE_OFFICER_EMAIL,
    officerPhone: env.VITE_BRAND_GRIEVANCE_OFFICER_PHONE,
    nodalName: env.VITE_BRAND_NODAL_OFFICER_NAME,
    nodalEmail: env.VITE_BRAND_NODAL_OFFICER_EMAIL,
    nodalPhone: env.VITE_BRAND_NODAL_OFFICER_PHONE,
  },

  cin: env.VITE_BRAND_CIN_NUMBER,
  gstin: env.VITE_BRAND_GSTIN,
} as const;
